import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import merge from 'deepmerge';



interface FilterState {
  traits: { [ trait: string ]: string };
  rarity: string;
}

const initialState: FilterState = {
  traits: {},
  rarity: 'All',
}



const service = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    setTraitFilter(state, action: PayloadAction<{ [ trait: string ]: string }>): FilterState {

      return {
        ...state,
        traits: merge(state.traits, action.payload)
      }
    },
    setRarityFilter(state, action: PayloadAction<string>): FilterState {
      return {
        ...state,
        rarity: action.payload,
      }
    },

  }
});





export const actions = {
  ...service.actions,
}

export default service.reducer;